import { Table } from 'antd';
import React from 'react';

import { PREFIX } from '@app/constants';
import { Filters } from '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/components';
import {
  usePaymentDocumentsRegistry,
  usePaymentDocumentsRegistryEffects,
} from '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/hooks';
import '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/styles/PaymentDocumentsRegistry.desktop.scss';

export const PaymentDocumentsRegistry: React.FC = () => {
  const {
    onReset,
    onSearch,
    organizationIds,
    setOrganizationIds,
    documentTypes,
    setDocumentTypes,
    statuses,
    setStatuses,
    period,
    setPeriod,
    handleSearchFilters,
    isFiltersLoading,
    filters,
    handleSearchData,
    searchBillsResult,
    isSearchBillsLoading,
    pageNumber,
    rowsPerPage,
    handleTableChange,
    columns,
    isGetSearchResultLoading,
  } = usePaymentDocumentsRegistry();

  usePaymentDocumentsRegistryEffects({ handleSearchFilters, handleSearchData });

  return (
    <div className={`${PREFIX}payment-documents`}>
      <Filters
        onReset={onReset}
        onSearch={onSearch}
        disabled={isFiltersLoading}
        organizationIds={organizationIds}
        setOrganizationIds={setOrganizationIds}
        documentTypes={documentTypes}
        setDocumentTypes={setDocumentTypes}
        statuses={statuses}
        setStatuses={setStatuses}
        period={period}
        setPeriod={setPeriod}
        filters={filters}
      />
      <Table
        columns={columns}
        loading={isSearchBillsLoading || isGetSearchResultLoading}
        dataSource={searchBillsResult?.Bills || []}
        pagination={{
          showSizeChanger: true,
          total: searchBillsResult?.CountBills,
          defaultCurrent: pageNumber,
          position: ['bottomLeft'],
          pageSize: rowsPerPage,
          onChange: handleTableChange,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
        }}
      />
    </div>
  );
};
